import React from 'react';
import './../css/hero.css';

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-content">
        <h1>SECURE YOUR DIGITAL WORLD</h1>
        <p>We offer proactive cybersecurity services designed to protect your assets and maintain the resilience of your digital ecosystem against evolving threats.</p>
        <a href='mailto:contact@defensek.com'><button className="cta-button">Guard Your Business Today</button></a>
      </div>
    </section>
  );
};

export default Hero;
